import { render } from "./DropdownButton.vue?vue&type=template&id=428514ae&scoped=true"
import script from "./DropdownButton.vue?vue&type=script&lang=js"
export * from "./DropdownButton.vue?vue&type=script&lang=js"

import "./DropdownButton.vue?vue&type=style&index=0&id=428514ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428514ae"]])

export default __exports__